var React = require('react');

function JunieLogo (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M16.0148 7.99931H24.0001V9.33326C24.0001 18.671 20.0075 24.0003 9.36696 24.0003H8.03613V15.9966H9.36696C14.0218 15.9966 16.0213 13.9989 16.0213 9.32679V7.9928L16.0148 7.99931Z","fill":"#48E054","key":0}),React.createElement("path",{"d":"M7.98519 7.9978H0V16.0015H7.98519V7.9978Z","fill":"#48E054","key":1}),React.createElement("path",{"d":"M15.9628 0.000244141H7.97754V8.00397H15.9628V0.000244141Z","fill":"#48E054","key":2})]);
}

JunieLogo.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = JunieLogo;

JunieLogo.default = JunieLogo;
